import MainLayout from '@/common/components/layouts/MainLayout';
import { Box } from 'styled-system/jsx';
import RankingSection from '../components/ranking/RankingSection';

const RankingPage = () => (
  <MainLayout header="titleHeader" title="رتبه بندی" navbar>
    <Ranking />
  </MainLayout>
);

function Ranking() {
  return (
    <Box paddingBottom="28px" display="flex" flexDirection="column">
      <RankingSection />
    </Box>
  );
}
export default RankingPage;
